import * as yup from 'yup';
type TFunction = (key: string, options?: Record<string, unknown>) => string;
export const initialEnterpriseDetailsDto = {
  name: '',
  siren: '',
  email: '',
  description: '',
  activityAreaIds: [],
};

export const enterpriseDetailsDtoSchema = (translate: TFunction) => {
  return yup.object().shape({
    name: yup
      .string()
      .required(translate('REQUIRED') ?? undefined)
      .test('no-empty-spaces', translate('REQUIRED'), (value) => {
        // Use a custom test to check if the value contains only spaces
        return value.trim() !== '';
      }),
    siren: yup
      .string()
      .required(translate('REQUIRED') ?? undefined)
      .matches(/^\d{9}$/, translate('SIREN_MAX')),
    logo: yup.mixed(),
    email: yup
      .string()
      .email(translate('INVALID_EMAIL_FORMAT') ?? undefined)
      .required(translate('REQUIRED') ?? undefined),
    description: yup
      .string()
      .required(translate('REQUIRED') ?? undefined)
      .test('no-empty-spaces', translate('REQUIRED'), (value) => {
        // Use a custom test to check if the value contains only spaces
        return value.trim() !== '';
      }),
    activityAreaIds: yup
      .array()

      .min(1, translate('REQUIRED') ?? undefined)
      .required(translate('REQUIRED') ?? undefined),
  });
};
